import React, { useState, Children } from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const MarketingSection = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    alert('Thank you for your submission! We will contact you soon.');
  };
  const marketingFeatures = [{
    title: 'Targeted Printed Media',
    description: 'We utilize high-quality printed materials, such as brochures and flyers, to showcase your property in local publications and targeted mailings, reaching potential buyers who prefer traditional media.',
    image: 'https://images.unsplash.com/photo-1616587894289-86480e533129?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    imageLeft: true
  }, {
    title: 'Proactive Client Outreach',
    description: 'We conduct proactive calling to search for potential clients and cross-referencing properties to identify suitable matches and opportunities.',
    image: 'https://images.unsplash.com/photo-1557425955-df376b5903c8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    imageLeft: false
  }, {
    title: 'Dynamic Social Media Campaigns',
    description: 'We employ strategic social media marketing across platforms like Facebook, Instagram, and LinkedIn to engage potential buyers and generate interest through targeted ads and organic content.',
    image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    imageLeft: true
  }, {
    title: 'Specialized Chinese Platforms',
    description: 'We market your property on prominent Chinese real estate platforms, tapping into a significant buyer demographic and expanding your reach to international investors.',
    image: 'https://images.unsplash.com/photo-1629468855534-450c810c38a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    imageLeft: false
  }, {
    title: 'Unmatched Global Visibility',
    description: "We collaborate with leading international brokerage firms to access a broader network of buyers and investors, enhancing your property's visibility and appeal on a global scale.",
    image: 'https://images.unsplash.com/photo-1605629921711-2f6b00c6bbf4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    imageLeft: true
  }, {
    title: 'Premium Quality Media',
    description: 'We create a compelling presentation of your property with high-quality media, including a personalized website, professional videography, detailed 2D floor plans, and virtual tours, to captivate potential buyers and provide an immersive viewing experience.',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    imageLeft: false
  }];
  // Animation variants
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const listItem = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="w-full bg-[#f2f2ed]" data-id="element-527">
      {/* Hero Section */}
      <div className="pt-32 pb-20" data-id="element-528">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-529">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-530">
            <h1 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-531">
              MARKETING SERVICES
            </h1>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-532">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-533">
              <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-534">
                Strategic marketing solutions designed to showcase your property
                to the right audience.
              </h2>
            </motion.div>
            <motion.div className="text-[#3a4a56]" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-535">
              <motion.p className="text-lg mb-8" variants={listItem} data-id="element-536">
                Our comprehensive marketing strategies are designed to showcase
                your property to the right audience and maximize its value in
                the market. From professional photography to targeted digital
                campaigns, we ensure your property stands out.
              </motion.p>
              <motion.p className="text-lg mb-8" variants={listItem} data-id="element-537">
                At Immovendu, we believe that effective property marketing
                requires a multi-faceted approach. Our comprehensive strategy
                combines traditional methods with cutting-edge digital
                techniques to ensure your property receives maximum exposure to
                qualified buyers.
              </motion.p>
              <motion.p className="text-lg" variants={listItem} data-id="element-538">
                Each marketing plan is carefully tailored to highlight your
                property's unique features and appeal to the most relevant
                audience, ensuring optimal visibility and engagement.
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>
      {/* Marketing Features */}
      {marketingFeatures.map((feature, index) => <motion.div key={index} className="py-20 border-t border-[#3a4a56] last:border-b last:border-[#3a4a56]" initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeIn} transition={{
      duration: 0.6
    }} data-id="element-539">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-540">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-541">
              {feature.imageLeft ? <>
                  <motion.div initial={{
              opacity: 0,
              x: -50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} whileHover={{
              scale: 1.03
            }} data-id="element-542">
                    <img src={feature.image} alt={feature.title} className="w-full h-auto object-cover rounded-md shadow-md" onError={e => {
                e.currentTarget.src = 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80';
              }} data-id="element-543" />
                  </motion.div>
                  <motion.div className="text-[#3a4a56]" initial={{
              opacity: 0,
              x: 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} data-id="element-544">
                    <h2 className="text-3xl md:text-4xl font-normal leading-tight mb-8" data-id="element-545">
                      {feature.title}
                    </h2>
                    <p className="text-lg mb-8" data-id="element-546">{feature.description}</p>
                    <motion.ul className="space-y-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
                once: true
              }} data-id="element-547">
                      <motion.li className="flex items-start" variants={listItem} data-id="element-548">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-549" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-550">
                          Targeted audience reach
                        </span>
                      </motion.li>
                      <motion.li className="flex items-start" variants={listItem} data-id="element-551">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-552" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-553">
                          Professional execution
                        </span>
                      </motion.li>
                      <motion.li className="flex items-start" variants={listItem} data-id="element-554">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-555" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-556">
                          Measurable results
                        </span>
                      </motion.li>
                    </motion.ul>
                  </motion.div>
                </> : <>
                  <motion.div className="text-[#3a4a56]" initial={{
              opacity: 0,
              x: -50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} data-id="element-557">
                    <h2 className="text-3xl md:text-4xl font-normal leading-tight mb-8" data-id="element-558">
                      {feature.title}
                    </h2>
                    <p className="text-lg mb-8" data-id="element-559">{feature.description}</p>
                    <motion.ul className="space-y-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
                once: true
              }} data-id="element-560">
                      <motion.li className="flex items-start" variants={listItem} data-id="element-561">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-562" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-563">
                          Increased property visibility
                        </span>
                      </motion.li>
                      <motion.li className="flex items-start" variants={listItem} data-id="element-564">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-565" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-566">
                          Qualified buyer targeting
                        </span>
                      </motion.li>
                      <motion.li className="flex items-start" variants={listItem} data-id="element-567">
                        <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-568" />
                        <span className="text-[#3a4a56] text-lg" data-id="element-569">
                          Faster time to sale
                        </span>
                      </motion.li>
                    </motion.ul>
                  </motion.div>
                  <motion.div initial={{
              opacity: 0,
              x: 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} whileHover={{
              scale: 1.03
            }} data-id="element-570">
                    <img src={feature.image} alt={feature.title} className="w-full h-auto object-cover rounded-md shadow-md" onError={e => {
                e.currentTarget.src = 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80';
              }} data-id="element-571" />
                  </motion.div>
                </>}
            </div>
          </div>
        </motion.div>)}
      {/* Additional Services Section */}
      <div className="py-20" data-id="element-572">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-573">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-574">
            <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-575">
              PREMIUM SERVICES
            </h6>
            <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-576">
              Elevate Your Property Presentation
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 mb-20" data-id="element-577">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-578">
              <motion.div className="mb-8" data-id="element-579">
                <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Home Staging Services" className="w-full h-auto" data-id="element-580" />
              </motion.div>
              <h3 className="text-2xl font-normal text-[#3a4a56] mb-4" data-id="element-581">
                Home Staging Services
              </h3>
              <p className="text-[#3a4a56] mb-6" data-id="element-582">
                Presentation is key when it comes to selling your home. Our
                professional home staging services showcase your property in its
                best light, highlighting its unique features and creating a
                warm, inviting atmosphere that resonates with potential buyers.
              </p>
              <motion.ul className="space-y-3 mb-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-583">
                <motion.li className="flex items-start" variants={listItem} data-id="element-584">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-585" />
                  <span className="text-[#3a4a56]" data-id="element-586">
                    Professional interior arrangement
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-587">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-588" />
                  <span className="text-[#3a4a56]" data-id="element-589">
                    Strategic furniture placement
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-590">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-591" />
                  <span className="text-[#3a4a56]" data-id="element-592">Enhanced visual appeal</span>
                </motion.li>
              </motion.ul>
            </motion.div>
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-593">
              <motion.div className="mb-8" data-id="element-594">
                <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="International Marketing" className="w-full h-auto" data-id="element-595" />
              </motion.div>
              <h3 className="text-2xl font-normal text-[#3a4a56] mb-4" data-id="element-596">
                International Marketing
              </h3>
              <p className="text-[#3a4a56] mb-6" data-id="element-597">
                With our unparalleled global and local reach, we connect your
                property with qualified buyers worldwide. Our extensive network
                and local expertise ensure your property reaches the right
                audience, whether they're local or international investors.
              </p>
              <motion.ul className="space-y-3 mb-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-598">
                <motion.li className="flex items-start" variants={listItem} data-id="element-599">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-600" />
                  <span className="text-[#3a4a56]" data-id="element-601">
                    Multi-language property listings
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-602">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-603" />
                  <span className="text-[#3a4a56]" data-id="element-604">
                    International buyer network
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-605">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-606" />
                  <span className="text-[#3a4a56]" data-id="element-607">
                    Cross-border transaction expertise
                  </span>
                </motion.li>
              </motion.ul>
            </motion.div>
          </div>
        </div>
      </div>
      {/* Contact Form */}
      <div className="py-20 border-t border-[#3a4a56]" data-id="element-608">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-609">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-610">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6
          }} data-id="element-611">
              <h2 className="text-4xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-612">
                Let's discuss your marketing needs
              </h2>
              <p className="text-lg text-[#3a4a56] mb-8" data-id="element-613">
                Contact us to learn more about our comprehensive marketing
                services. Our team of experts is ready to develop a customized
                strategy to showcase your property to the right audience.
              </p>
              <motion.ul className="space-y-4 mb-8" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-614">
                <motion.li className="flex items-start" variants={listItem} data-id="element-615">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-616" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-617">
                    Customized marketing strategy
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-618">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-619" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-620">
                    Professional media production
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-621">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-622" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-623">
                    Global buyer network access
                  </span>
                </motion.li>
              </motion.ul>
            </motion.div>
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-624">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-625">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-626">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-627">
                    <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="First Name" required data-id="element-628" />
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-629">
                    <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Last Name" required data-id="element-630" />
                  </motion.div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-631">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-632">
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Phone Number" required data-id="element-633" />
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-634">
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Email Address" required data-id="element-635" />
                  </motion.div>
                </div>
                <motion.div whileHover={{
                y: -5
              }} transition={{
                type: 'spring',
                stiffness: 300
              }} data-id="element-636">
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" rows={4} placeholder="Tell us about your property and marketing needs" data-id="element-637"></textarea>
                </motion.div>
                <div data-id="element-638">
                  <motion.button type="submit" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} transition={{
                  type: 'spring',
                  stiffness: 400
                }} data-id="element-639">
                    Submit
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};